<template>
  <div class="c-startpage-hero-template-banner">
    <div v-if="entries?.length > 0" class="hero-banner option-line-bullets carousel hidden lg:block">
      <template v-if="entries.length == 1">
        <template v-for="entry in entries" :key="entry">
          <template v-if="entry.type == 'Primary'">
            <StartpageHeroElementBannerSimple :entry="entry" />
          </template>
          <template v-if="entry.type == 'Secondary'">
            <StartpageHeroElementBannerDetailed :entry="entry" />
          </template>
        </template>
      </template>
      <template v-if="entries.length > 1">
        <NuxtCarousel v-bind="carouselConfig" class="tiles">
            <NuxtSlide v-for="entry in entries" :key="entry.priority">
              <template v-if="entry.type == 'Primary'">
                <StartpageHeroElementBannerSimple :entry="entry" />
              </template>
              <template v-if="entry.type == 'Secondary'">
                <StartpageHeroElementBannerDetailed :entry="entry" />
              </template>
            </NuxtSlide>
            <template #addons>
              <NuxtNavigation />
              <NuxtPagination />
            </template>
        </NuxtCarousel>
      </template>
    </div>
    <div v-else>
      <BasicSkeleton auto>
        <template #placeholder>
        <SkeletonElementImage class="w-full h-[500px] rounded-3xl opacity-30" />
        </template>
      </BasicSkeleton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useMutationObserver } from "@vueuse/core";
import type { SliderEntry } from '../SliderStructure';

defineProps<{
  entries: SliderEntry[];
}>();

const slider = useTemplateRef('slider');
const carouselConfig = {
  itemsToShow: 1,
  gap: 24,
  height: 500,
  breakpointMode: 'carousel',
  snapAlign: 'center',
  wrapAround: true,
  autoplay: 3500,
  pauseAutoplayOnHover: true,
} as const;

useMutationObserver(slider, (mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes') {
      setTabIndex(mutation.target as HTMLBodyElement, mutation.oldValue === 'true' ? 0 : -1);
    }
  }
}, {
  attributes: true,
  attributeFilter: ['aria-hidden'],
  attributeOldValue: true,
  subtree: true,
});

const readyHandler = () => {
  const sliderInnerTrack = slider.value?.container?.querySelector('.vueperslides__track-inner');
  const slideElements = sliderInnerTrack?.querySelectorAll('.vueperslide:not(.vueperslide--visible)') ?? [];

  for (const slideElement of slideElements) {
    setTabIndex(slideElement, -1);
  }

  useMutationObserver(sliderInnerTrack, (mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          setTabIndex(node as HTMLBodyElement, -1);
        }
      }
    }
  }, {
    childList: true,
  });
};

const setTabIndex = (element: HTMLBodyElement, tabIndex: number): void => {
  element.tabIndex = tabIndex;
  const children = element.querySelectorAll('a');
  for (const child of children) {
    child.tabIndex = tabIndex;
  }
};
</script>